import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-accept-terms-policy-check',
  templateUrl: './accept-terms-policy-check.component.html',
  styleUrls: ['./accept-terms-policy-check.component.css']
})
export class AcceptTermsPolicyCheckComponent implements OnInit {
  
  checked = false;
  indeterminate = false;

  termsUrl = 'https://voyjaleas.com/#/terms';
  privacyUrl = 'https://voyjaleas.com/#/privacy-policy';

  termsVersion = 'v1.0';
  policyVersion = 'v1.0';

  @Output() policyChecked = new EventEmitter(); // Emit event when CTA is clicked

  constructor() { }

  ngOnInit(): void {
  }

  onTermsAccepted(){
    let termsObj = {
      termsVersion: this.termsVersion,
      policyVersion : this.policyVersion,
      checked: this.checked
    }
    this.policyChecked.emit(termsObj);
  }

}
